<ng-container *ngIf="multiLang; else notMultiLangTemplate">
  <!-- ! test -->

  <p-tabView>
    <p-tabPanel
      *ngFor="let lang of appConfig.languages"
      [header]="lang.name"
      [rightIcon]="
        CustomUtils.getLangFormGroup(form, lang.code)?.invalid
          ? 'pi pi-exclamation-triangle text-pink-500'
          : ''
      "
      [tooltip]="
        CustomUtils.getLangFormGroup(form, lang.code)?.invalid
          ? ('MODULES.PAGES.tabTooltipRequired' | translate)
          : ''
      "
    >
      <!-- * MAIN FORM -->
      <section
        class="grid"
        [ngClass]="styleClass"
        [formGroup]="CustomUtils.getLangFormGroup(form, lang.code)"
      >
        <ng-container *ngFor="let field of fields">
          <!-- * IF - group of fields -->
          <ng-container *ngIf="field?.group; else elseTemplate">
            <!-- * Define column size -->
            <div [class]="field.colSize">
              <ng-container *ngFor="let subfield of field.group">
                <!-- * Find and use type of control -->

                <app-form-factory-core
                  [field]="subfield"
                  [form]="CustomUtils.getLangFormGroup(form, lang.code)"
                  [mainForm]="mainForm"
                  [langCode]="lang.code"
                ></app-form-factory-core>
              </ng-container>
            </div>
          </ng-container>
          <!-- * IF - single field -->
          <ng-template #elseTemplate>
            <!-- * Define column size -->
            <div [class]="field.colSize">
              <app-form-factory-core
                [field]="field"
                [form]="CustomUtils.getLangFormGroup(form, lang.code)"
                [mainForm]="mainForm"
                [langCode]="lang.code"
              ></app-form-factory-core>
            </div>
          </ng-template>
        </ng-container>
      </section>
    </p-tabPanel>
  </p-tabView>
</ng-container>
<ng-template #notMultiLangTemplate>
  <!-- * MAIN FORM -->
  <section class="grid" [ngClass]="styleClass" [formGroup]="form">
    <ng-container *ngFor="let field of fields">
      <!-- * IF - group of fields -->
      <ng-container *ngIf="field.group; else elseTemplate">
        <!-- * Define column size -->
        <div [class]="field.colSize">
          <ng-container *ngFor="let subfield of field.group">
            <!-- * Find and use type of control -->
            <app-form-factory-core
              [field]="subfield"
              [form]="form"
              [mainForm]="mainForm"
            ></app-form-factory-core>
          </ng-container>
        </div>
      </ng-container>
      <!-- * IF - single field -->
      <ng-template #elseTemplate>
        <!-- * Define column size -->
        <div [class]="field.colSize">
          <app-form-factory-core
            [field]="field"
            [form]="form"
            [mainForm]="mainForm"
          ></app-form-factory-core>
        </div>
      </ng-template>
    </ng-container>
  </section>
</ng-template>
